import React from "react"
import autobind from "class-autobind"
import NotesDrawerContent from "./NotesDrawerContent"
import { IApprovalValidation, INoteObjectData } from "../../../models"
interface IProps {
    openNotesDrawer: boolean
    drawerTitle: string
    objectData: INoteObjectData
    objectName: string
    dataType: string
    validationMessages?: IApprovalValidation[]
    closeNotesDrawer(): void
    readValidationMessage:(msgeId:string) => Promise<IApprovalValidation>
}

interface IState {
    openDrawer: boolean
}

export default class NotesDrawer extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            openDrawer: false
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !this.props.openNotesDrawer && nextProps.openNotesDrawer &&
            setTimeout(() =>
                this.setState({ openDrawer: true }), 10
            )
    }

    closeNotesDrawer() {
        this.setState({ openDrawer: false }, () =>
            setTimeout(() =>
                this.props.closeNotesDrawer(), 100
            )
        )
    }

    render() {
        return this.props.openNotesDrawer &&
            <NotesDrawerContent
                open={this.state.openDrawer}
                title={this.props.drawerTitle}
                objectData={this.props.objectData}
                objectName={this.props.objectName}
                closeNotesDrawer={this.closeNotesDrawer}
                dataType={this.props.dataType}
                validationMessages={this.props.validationMessages}
                readValidationMessage={this.props.readValidationMessage}
            />
    }
}
